<template >
  <div v-if="company">
    <v-parallax
      dark
      :slot="company.vollername"
      :src="ImageHeaderUrl"
      :alt="company.vollername + ' Hintergrund'"
      class="parallaxprem"
      :key="company.id"
    >
      <v-layout
        row
        wrap
        :style="AbstandOben"
        class="ml-2"
      >
        <v-flex
          align-self-end
          offset-lg2
          lg8
          offset-md1
          md10
          sm12
          offset-sm0
          xs12
          class="rounded-card"
          :style="ProfilOpacity"
        >
          <v-layout
            row
            wrap
            fill-height
            align-space-around
            justify-space-between
            class="py-4"
            style="xborder: 1px solid blue;"
          >
            <v-flex
              align-self-end
              md8
              sm10
              xs12
              order-xs2
              order-md1
              class="px-0 pt-3"
            >
              <v-card
                class="pl-3 pb-1 title"
                flat
                color="transparent"
                dark
              >
                <v-card-title>
                  <h1
                    style="line-height: 1;"
                    :class="this.ÜberschriftSize"
                  >{{ company.vollername }}</h1>
                </v-card-title>
                <v-card-text>
                  <v-layout
                    row
                    wrap
                    class="d-inline-flex"
                  >
                    <listing-save
                      :id="company.id"
                      :company="company"
                      :buttonfarbe="ProfilFarbe"
                      :lighttext="ProfilDark"
                      is-bigbutton
                    ></listing-save>

                    <sharemodal
                      :id="company.id"
                      :company="company"
                      :buttonfarbe="ProfilFarbe"
                      :lighttext="ProfilDark"
                      is-bigbutton
                    ></sharemodal>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex
              md4
              sm8
              xs12
              order-xs1
              order-sm1
              order-md2
              align-self-baseline
              class="px-3 pt-5"
              v-if="company.image_logo"
            >
              <v-card
                flat
                class="pa-3"
              >
                <v-img :src="'/' + company.image_logo"></v-img>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-parallax>
    <v-divider></v-divider>
    <v-layout
      row
      wrap
    >
      <v-flex
        xl8
        offset-xl2
        lg8
        offset-lg2
        md12
        offset-md0
        class="px-0"
      >
        <v-layout
          row
          wrap
        >
          <v-flex
            xl8
            md7
            class="pa-3"
            order-xs2
            order-sm1
          >
            <v-card
              flat
              class="px-4 py-1 mt-0 subheading"
            >
              <div
                v-if="company.beschreibung"
                class="mt-2"
              >
                <span
                  style="white-space: pre-line;"
                  class="subheading"
                >{{ company.beschreibung }}</span>
                <v-divider class="mt-4"></v-divider>
              </div>

              <v-container
                grid-list-md
                class="pa-0"
              >
                <v-layout
                  row
                  wrap
                  v-if="company.offen_montag"
                >
                  <v-flex
                    xs6
                    md4
                    offset-md2
                    class="py-0"
                  >
                    <v-list>
                      <v-subheader class="subheading">
                        <v-icon
                          :color="ProfilFarbe"
                          left
                          large
                        >timer</v-icon>Öffnungszeiten
                      </v-subheader>
                      <v-divider></v-divider>
                    </v-list>
                  </v-flex>
                </v-layout>
                <v-layout
                  row
                  wrap
                  v-if="company.offen_montag"
                >
                  <v-flex
                    xs6
                    md4
                    offset-md2
                  >
                    <v-card
                      tile
                      flat
                    >
                      <v-card-text class="pa-0">
                        <v-list>
                          <v-list-tile>
                            <v-list-tile-content>
                              <v-list-tile-title>{{ company.offen_montag }} - {{ company.zu_montag }}</v-list-tile-title>
                              <v-list-tile-sub-title>Montag</v-list-tile-sub-title>
                            </v-list-tile-content>
                          </v-list-tile>
                          <v-divider></v-divider>
                          <v-list-tile>
                            <v-list-tile-content>
                              <v-list-tile-title>{{ company.offen_dienstag }} - {{ company.zu_dienstag }}</v-list-tile-title>
                              <v-list-tile-sub-title>Dienstag</v-list-tile-sub-title>
                            </v-list-tile-content>
                          </v-list-tile>
                          <v-divider></v-divider>
                          <v-list-tile>
                            <v-list-tile-content>
                              <v-list-tile-title>{{ company.offen_mittwoch }} - {{ company.zu_mittwoch }}</v-list-tile-title>
                              <v-list-tile-sub-title>Mittwoch</v-list-tile-sub-title>
                            </v-list-tile-content>
                          </v-list-tile>
                          <v-divider></v-divider>
                        </v-list>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex
                    xs6
                    md4
                  >
                    <v-card
                      tile
                      flat
                      class="pa-0"
                    >
                      <v-card-text class="pa-0">
                        <v-list>
                          <v-list-tile>
                            <v-list-tile-content>
                              <v-list-tile-title>{{ company.offen_donnerstag }} - {{ company.zu_donnerstag }}</v-list-tile-title>
                              <v-list-tile-sub-title>Donnerstag</v-list-tile-sub-title>
                            </v-list-tile-content>
                          </v-list-tile>
                          <v-divider></v-divider>
                          <v-list-tile>
                            <v-list-tile-content>
                              <v-list-tile-title>{{ company.offen_freitag }} - {{ company.zu_freitag }}</v-list-tile-title>
                              <v-list-tile-sub-title>Freitag</v-list-tile-sub-title>
                            </v-list-tile-content>
                          </v-list-tile>
                          <v-divider></v-divider>
                          <span v-if="company.offen_samstag">
                            <v-list-tile>
                              <v-list-tile-content>
                                <v-list-tile-title>{{ company.offen_samstag }} - {{ company.zu_samstag }}</v-list-tile-title>
                                <v-list-tile-sub-title>Samstag</v-list-tile-sub-title>
                              </v-list-tile-content>
                            </v-list-tile>
                            <v-divider></v-divider>
                          </span>
                          <span v-if="company.offen_sonntag">
                            <v-list-tile>
                              <v-list-tile-content>
                                <v-list-tile-title>{{ company.offen_sonntag }} - {{ company.zu_sonntag }}</v-list-tile-title>
                                <v-list-tile-sub-title>Sonntag</v-list-tile-sub-title>
                              </v-list-tile-content>
                            </v-list-tile>
                            <v-divider></v-divider>
                          </span>

                        </v-list>
                        <v-list v-if="company.mittag_von">
                          <v-list-tile>
                            <v-list-tile-content>
                              <v-list-tile-title>{{ company.mittag_von }} - {{ company.mittag_bis }}</v-list-tile-title>
                              <v-list-tile-sub-title>Mittagspause</v-list-tile-sub-title>
                            </v-list-tile-content>
                          </v-list-tile>
                          <v-divider></v-divider>
                        </v-list>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>

              <v-container grid-list-xl>
                <v-layout wrap>
                  <v-flex
                    xs12
                    class="my-3"
                  >
                    <v-layout
                      row
                      wrap
                      align-content-center
                      justify-space-around
                      v-if="company.innungen.length > 0"
                    >
                      <v-flex
                        xs6
                        v-for="innung in company.innungen"
                        :key="innung.id"
                      >
                        <v-card flat :to="{ name: 'Innung', params: { slug: innung.slug }}">
                          <v-img
                            :src="'/' + innung.logo"
                            v-if="innung.logo"
                            contain
                            height="120px"
                          ></v-img>
                          <v-card-text class="text-xs-center">
                            <span class="subheading">
                              <strong>Fachbetrieb</strong>
                              <br>
                              {{ innung.name }}
                            </span>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                    </v-layout>
                    <v-layout
                      row
                      wrap
                      align-content-center
                      justify-space-around
                      v-else
                    >
                      <v-flex xs12>
                        <v-card
                          flat
                          v-if="company.innung"
                        >
                          <div v-if="company.innung.logo">
                            <v-img
                              :src="'/' + company.innung.logo"
                              contain
                              height="120px"
                            ></v-img>
                          </div>
                          <v-card-text class="text-xs-center">
                            <span class="subheading">
                              <strong>Fachbetrieb</strong>
                              <br>
                              {{ company.innung.name }}
                            </span>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12>
                    <v-card flat>
                      <KHLogo :khstadt="KHStadt"></KHLogo>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
            <v-container
              class="px-0"
              grid-list-lg
              v-if="company.facebook || company.twitter || company.whatsapp || company.instagram "
            >
              <v-layout>
                <v-flex>
                  <h3 class="headline">
                    Unsere Social Media Kanäle
                  </h3>
                </v-flex>
              </v-layout>
              <v-layout
                row
                wrap
              >
                <v-flex
                  xs4
                  v-if="company.facebook"
                >
                  <v-hover>
                    <v-card
                      flat
                      class="pa-3"
                      slot-scope="{ hover }"
                      :class="`elevation-${hover ? 3 : 0}`"
                      :href="company.facebook"
                      target="_blank"
                    >
                      <v-img
                        max-height="70"
                        contain
                        src="././img/logos/logo_facebook.png"
                      />
                      <v-card-text class="text-xs-center subheading text-truncate">
                        {{ company.facebook | trim }}
                      </v-card-text>
                    </v-card>
                  </v-hover>
                </v-flex>

                <v-flex
                  xs4
                  v-if="company.twitter"
                >
                  <v-hover>
                    <v-card
                      flat
                      class="pa-3"
                      slot-scope="{ hover }"
                      :class="`elevation-${hover ? 3 : 0}`"
                      :href="company.twitter"
                      target="_blank"
                    >
                      <v-img
                        max-height="70"
                        contain
                        src="././img/logos/logo_twitter.png"
                      />
                      <v-card-text class="text-xs-center subheading text-truncate">
                        {{ company.twitter | trim }}
                      </v-card-text>
                    </v-card>
                  </v-hover>
                </v-flex>

                <v-flex
                  xs4
                  v-if="company.instagram"
                >
                  <v-hover>
                    <v-card
                      flat
                      class="pa-3"
                      slot-scope="{ hover }"
                      :class="`elevation-${hover ? 3 : 0}`"
                      :href="company.instagram"
                      target="_blank"
                    >
                      <v-img
                        max-height="70"
                        contain
                        src="././img/logos/logo_insta.png"
                      />
                      <v-card-text class="text-xs-center subheading text-truncate ">
                        {{ company.instagram | trim }}
                      </v-card-text>
                    </v-card>
                  </v-hover>
                </v-flex>

                <v-flex
                  xs4
                  v-if="company.whatsapp"
                >
                  <v-hover>
                    <v-card
                      flat
                      class="pa-3"
                      slot-scope="{ hover }"
                      :class="`elevation-${hover ? 3 : 0}`"
                      :href="'https://wa.me/' + company.whatsapp"
                      target="_blank"
                    >
                      <v-img
                        max-height="70"
                        contain
                        src="././img/logos/logo_whatsapp_trans.png"
                      />
                      <v-card-text class="text-xs-center subheading text-truncate">
                        {{ company.whatsapp }}
                      </v-card-text>
                    </v-card>
                  </v-hover>
                </v-flex>

              </v-layout>
            </v-container>

            <v-container
              class="px-0"
              grid-list-lg
              v-if="company.zertifikate.length > 0"
            >
              <v-layout>
                <v-flex>
                  <h3 class="headline">
                    Qualitätsmerkmale
                  </h3>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex
                  xs4
                  v-for="cert in company.zertifikate"
                  :key="cert.name"
                >
                  <v-card
                    flat
                    class="pa-3"
                  >
                    <v-img
                      :src="'/' + cert.logo"
                      v-if="cert.logo"
                      contain
                      max-height="80"
                    ></v-img>
                    <v-card-text class="text-xs-center subheading">
                      {{ cert.name }}
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
            <v-container
              grid-list-lg
              px-0
              v-if="company.stellen"
            >
              <stellen
                :company="company"
                v-if="company.stellen.length > 0"
              ></stellen>
            </v-container>

          </v-flex>
          <v-flex
            d-flex
            xl4
            md5
            class="mt-3 stickycontainer"
            order-xs1
            order-sm2
          >
            <v-card
              flat
              color
              class="item pinnedbox"
            >
              <v-card-text pt-0>
                <v-list two-line>
                  <v-list-tile
                    v-if="company.telefon"
                    v-bind:href="'tel:' + company.telefon_link"
                  >
                    <v-list-tile-action>
                      <v-icon :color="ProfilFarbe">phone</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>{{ company.telefon }}</v-list-tile-title>
                      <v-list-tile-sub-title>Telefon</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <div v-if="company.fax">
                    <v-divider inset></v-divider>
                    <v-list-tile>
                      <v-list-tile-action>
                        <v-icon :color="ProfilFarbe">print</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>{{ company.fax }}</v-list-tile-title>
                        <v-list-tile-sub-title>Fax</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </div>
                  <div v-if="company.email">
                    <v-divider inset></v-divider>
                    <v-list-tile v-bind:href="'mailto:' + company.email">
                      <v-list-tile-action>
                        <v-icon :color="ProfilFarbe">mail</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          {{ company.email }}
                          <!-- <a :href="`mailto:${company.email}`">{{ company.email }}</a> -->
                        </v-list-tile-title>
                        <v-list-tile-sub-title>E-mail</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </div>
                  <div v-if="company.website">
                    <v-divider inset></v-divider>
                    <v-list-tile>
                      <v-list-tile-action>
                        <v-icon :color="ProfilFarbe">web</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          <a
                            :href="`${company.website}`"
                            target="_blank"
                          >{{ WebseiteOhneHttp }}</a>
                        </v-list-tile-title>
                        <v-list-tile-sub-title>Webseite</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </div>
                  <v-divider inset></v-divider>
                  <v-list-tile
                    v-bind:href="RoutenLink"
                    target="_blank"
                    v-if="company.stadt"
                  >
                    <v-list-tile-action>
                      <v-icon :color="ProfilFarbe">location_on</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>
                        <a
                          :href="RoutenLink"
                          target="_blank"
                          v-if="company.address"
                        >{{ company.address }}</a>
                        <span v-else>{{ company.stadtmitteil }}</span>
                      </v-list-tile-title>
                      <v-list-tile-sub-title>{{ company.plz }} {{ company.stadtmitteil }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout
      row
      wrap
      class="ml-3 mb-4"
      v-if="company.leistungen"
    >
      <v-flex
        xalign-self-end
        offset-lg2
        lg8
        offset-md1
        md10
        sm12
        offset-sm0
        xs12
      >
        <h3 class="headline my-2">Verknüpfte Leistungen</h3>
        <v-layout
          row
          wrap
        >
          <div
            v-for="leistung in company.leistungen"
            :key="'l' + leistung.id"
            class="subheading py-2 px-3 mx-1 my-1 white"
            text-color="grey darken-4"
          >
            {{ leistung.leistung }}
          </div>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout
      row
      wrap
      class="ml-3 mb-4"
      v-if="company.leistungenjson"
    >
      <v-flex
        xalign-self-end
        offset-lg2
        lg8
        offset-md1
        md10
        sm12
        offset-sm0
        xs12
      >
        <h3 class="headline my-2">Leistungspalette</h3>

        <v-layout
          row
          wrap
        >
          <v-flex
            d-flex
            fill-height
            xs12
            md6
            lg4
            v-for="leistung in company.leistungenjson"
            :key="'lcard' + leistung.id"
          >
            <v-card
              tile
              class="subheading mx-2 my-2 white"
              text-color="grey darken-4"
              v-if="leistung.title"
            >
              <v-card-title
                class="pa-0"
                width="100%"
              >
                <v-img
                  :src="leistung.selected"
                  width="100%"
                  height="300px"
                  v-if="leistung.selected"
                >
                </v-img>
              </v-card-title>
              <v-card-title><h2 class="headline">{{ leistung.title }}</h2></v-card-title>
              <v-card-text class="py-0">
                <div v-if="leistung.text">
                  <nl2br
                    tag="p"
                    :text="leistung.text"
                  />
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout
      row
      wrap
      class="ml-3 mb-4"
    >
      <v-flex
        xalign-self-end
        offset-lg2
        lg8
        offset-md1
        md10
        sm12
        offset-sm0
        xs12
      >
       
      </v-flex>
    </v-layout>
    <microsite
      v-if="company.premium_freigeschaltet"
      :company="company"
    ></microsite>

    <v-container v-if="company.impressum_text">
      <v-layout
        row
        wrap
      >
        <v-flex
          xl8
          offset-xl2
          lg8
          offset-lg2
          md12
          offset-md0
          class="px-0"
        >
          <v-layout
            row
            wrap
          >
            <v-flex
              xs12
              class="mb-3"
            >
              <h3 class="subheading">Impressum / Datenschutz</h3>
            </v-flex>
            <v-flex xs12>
              <span
                style="white-space: pre-line;"
                v-text="company.impressum_text"
              ></span>
            </v-flex>

          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>

    <v-container v-else-if="company.impressum_link">
      <v-layout
        row
        wrap
      >
        <v-flex
          xl8
          offset-xl2
          lg8
          offset-lg2
          md12
          offset-md0
          class="px-0"
        >
          <h4 class="subheading">Impressum / Datenschutz</h4>
          <p>
            Das vollständige Impressum finden Sie auf der offiziellen Homepage des Betriebs:
            <a
              :href="company.impressum_link"
              target="_blank"
            >{{ company.impressum_link }}</a>
          </p>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container v-else>
      <v-layout
        row
        wrap
      >
        <v-flex
          xl8
          offset-xl2
          lg8
          offset-lg2
          md12
          offset-md0
          class="px-0"
        >
          <h4 class="subheading">Impressum / Datenschutz</h4>
          <p>
            Das vollständige Impressum finden Sie auf der offiziellen Homepage des Betriebs (siehe oben)
          </p>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import ListingSave from '~/components/ListingSave.vue'
import FehlerMelden from '~/components/FehlerMelden.vue'
import NachrichtErstellen from '~/components/nachrichten/NachrichtErstellen.vue'
import KHLogo from '~/components/companies/khlogo.vue'
import sharemodal from '~/components/companies/sharemodal.vue'
import microsite from '~/pages/companies/microsite.vue'
import Stellen from '~/components/companies/stellen.vue'

export default {
  props: {
    company: { type: Object, required: true }
  },
  components: {
    ListingSave,
    NachrichtErstellen,
    FehlerMelden,
    KHLogo,
    sharemodal,
    microsite,
    Stellen
  },
  metaInfo () {
    return {
      meta: [{ name: 'description', content: this.company.beschreibung }]
    }
  },

  data () {
    return {
      loading3: false,
      rating: 3,
      page: 'Type3',
      isCompany: true,
      model: null
    }
  },
  filters: {
    trim: function (string) {
      var result = string.replace(/(^\w+:|^)\/\//, '')

      return result
    }
  },
  mounted: function () {
    this.setRendered()
  },
  methods: {
    setRendered: function () {
      window.IS_RENDERED = true
    }
  },
  computed: {
    AbstandOben: function () {
      var abstand = '400px'

      if (this.company.image_header) {
        abstand = '550px'
      }
      if (this.company.profilabstand) {
        abstand = this.company.profilabstand + 'px'
      }
      var styleObject = 'min-height:' + abstand
      return styleObject
    },
    ProfilOpacity: function () {
      var opacity = '0.6'

      if (this.company.image_header) {
        opacity = '0.7'
      }
      if (this.company.profilopacity) {
        opacity = this.company.profilopacity
      }
      const styleObject = 'background:rgba(0,0,0,' + opacity + ');'
      return styleObject
    },
    ImageHeaderUrl: function () {
      var url = '/img/grey.png'
      if (this.company.image_header) {
        url = '/' + this.company.image_header
      }
      return url
    },
    ProfilFarbe: function () {
      var farbe
      if (this.company.profilfarbe) {
        farbe = this.company.profilfarbe
      } else {
        farbe = 'accent '
      }
      return farbe
    },
    ProfilFarbenStyle: function () {
      var farbe
      if (this.company.profilfarbe) {
        farbe = this.company.profilfarbe
      } else {
        farbe = '#212121'
      }
      const styleObject = 'color: ' + farbe + ';'
      return styleObject
    },
    ProfilDark: function () {
      var dark = false
      if (this.company) {
        if (this.company.profildark) {
          if (this.company.profildark === 1) {
            dark = true
          }
        }
      }
      return dark
    },
    WebseiteOhneHttp: function () {
      if (this.company) {
        if (this.company.website) {
          return this.company.website.replace(/^https?\:\/\//i, '')
        }
      }
    },
    KHStadt: function () {
      var stadt
      if (this.company) {
        if (this.company.innungen) {
          if (this.company.innungen.length > 0) {
            stadt = this.company.innungen[0].stadt
          } else {
            if (this.company.innung) {
              stadt = this.company.innung.stadt
            }
          }
        } else {
          if (this.company.innung) {
            if (this.company.innung.stadt) {
              stadt = this.company.innung.stadt
            }
          }
        }
      }
      return stadt
      // var stadt
      // if (this.company) {
      //   if (this.company.innungen.length > 0) {
      //     stadt = this.company.innungen[0].stadt
      //   } else {
      //     stadt = this.company.innung.stadt
      //   }
      // }
      // return stadt
    },
    ÜberschriftSize: function () {
      if (this.$vuetify.breakpoint.name === 'xs') {
        return 'display-1'
      } else {
        return 'display-3'
      }
    },
    RoutenLink: function () {
      return `http://maps.google.de/maps?daddr=${this.company.address}+${this.company.plz}+${this.company.stadt}`
    }
  }
}
</script>


<style>
.parallaxprem {
  height: 100% !important;
}
.stickycontainer {
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
}
.chipwrap {
  white-space: wrap !important;
  border: 1px solid red;
}
.pinnedbox {
  position: -webkit-sticky;
  position: sticky !important;
  top: 4em;
}
.rounded-card {
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}

.linehoeher {
  line-height: 1.6 !important;
}
.linehoehertext {
  line-height: 1.8 !important;
  font-size: 20px;
  font-weight: 300;
}
</style>